import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  ControlLabel,
  Alert,
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createHashHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";

import isEmpty from "lodash.isempty";
import { getReport } from "../../../redux/actions/reportAction";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import loader from "../../../style/loader/loader.scss";
import {aclUtil} from "../../util"

const history = createHashHistory();

const propTypes = {
  getReport: PropTypes.func.isRequired
};

let isLoading = "false", csvData = [];
class EmailSubscribers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'SUBSCRIBERS_REPORT',
      path: ["Home", "Email Subscribers Report"],
      links: ["home", "report/email/subscribers"],
      disabled: false,
      isLoading: "false",
      csvData: "",
      reportData: "",
    };

    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear = this.Clear.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  Clear = () => {};

  componentWillMount() {
    isLoading = "true";
    this.props.clearAlert();
    this.handleDismiss();
    this.props.getReport({site_id: localStorage.getItem("siteID")}, 'report/email-subscribers');
  }
  componentWillReceiveProps(nextProps) {

    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.props.history.push("/restrictedAccess");
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        isLoading = "false";
      }
    }

    if (this.props.reportData !== nextProps.reportData) {
      if (nextProps.reportData) {
        isLoading = "false";
        this.setState({ reportData: nextProps.reportData });
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.state.reportData === nextState.reportData) {
      return false
    }
    return true
  }
    
  render() {
    let { reportData } = this.state;

    return (
      <div className="col-lg-12 add-sub-admin">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} links={this.state.links}/>
          </div>
        </div>
        <div className="panel">
          <header className="panel-heading">Email Subscribers Report</header>
        </div>
        <div className="panel">
          <div className="panel-body">
            <table className="table table-hover table-bordered">
              <thead>
                <tr>
                  <th></th>
                  <th>Total</th>
                  <th>Today</th>
                  <th>Optouts Total</th>
                  <th>Optouts Today</th>
                  <th>New Signup Total</th>
                  <th>New Signup Today</th>
                </tr>
              </thead>
              <tbody>
                {(reportData && reportData.total_record) ?
                  <tr >
                    <td><b>All Markets</b></td>
                    <td>{reportData.total_record}</td>
                    <td>{reportData.today_record}</td>
                    <td>{reportData.optouts_total}</td>
                    <td>{reportData.optouts_today_record}</td>
                    <td>{reportData.new_signup_total}</td>
                    <td>{reportData.new_signup_today}</td>
                  </tr>
                : null}
                {(reportData.data && reportData.data.length > 0) ?
                  reportData.data.map((data, index) =>
                    <tr key={index}>
                      <td>{data.title}</td>
                      <td>{data.total}</td>
                      <td>{data.today}</td>
                      <td>{data.optouts_total}</td>
                      <td>{data.optouts_today}</td>
                      <td>{data.new_signup_total}</td>
                      <td>{data.new_signup_today}</td>
                    </tr>
                  )
                  :
                  <tr>
                    <td colSpan="6" style={{textAlign : 'center'}}>Data Not Available</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    error: state.reportReducer.error,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    reportData: state.reportReducer.reportData,
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    renderAlert,
    clearAlert,
    getReport,
  })
)(EmailSubscribers);


// WEBPACK FOOTER //
// ./src/app/views/admin/reports/EmailSubscribers.js